const getLimits = (rootState) => rootState.ws.integration.settings.limits;

export default getLimits;
